import axios from "axios";
const ConfigBaseURL = process.env.NODE_ENV === "development" ? "/api" : "/"; //默认路径，这里也可以使用env来判断环境
//使用create方法创建axios实例
export const Axios = axios.create({
  timeout: 7000, // 请求超时时间
  baseURL: ConfigBaseURL,
  method: "post",
  headers: {
    "Content-Type": "application/json;charset=UTF-8"
  }
});
// 添加请求拦截器
Axios.interceptors.request.use(config => {
  return config;
});
// 添加响应拦截器
Axios.interceptors.response.use(
  response => {
    // console.log(response)
    return response.data;
  },
  error => {
    const msg = error.Message !== undefined ? error.Message : "";
    return Promise.reject(error);
  }
);
